import Mustache from 'mustache'

import html from './Login.html'
import Page from '../Page'
import _ from '../Manager'

class Login extends Page{
	id;

	html(){
		return Mustache.render(html, {})
	}

	login(){
		let user= document.getElementById('loginUser').value
		let password= document.getElementById('loginPassword').value

		this.showError('')
		_.request('auth', 'login', {user: user, password: password})
			.then( this.onLoginOk.bind(this) )
			.catch( this.onLoginError.bind(this) )
	}

	onLoginOk( response ){
		_.setAuthToken( response.token )
		_.switchTo( 'Bowling' )
	}

	onLoginError( response ){
		this.showError( response && response.errorMsj ? response.errorMsj : 'Usuario o contraseña incorrectos.' )
	}

	showError( msg ){
		let root= document.getElementById('loginError')
		if (root) root.innerHTML= msg
	}
}

export default Login
